import { User } from 'oidc-client-ts';
import { PropsWithChildren, ReactElement, useEffect } from 'react';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { userManager } from './userManager';

// removes the ?code&state query Zitadel appends to the redirect uri while keeping any other query params and the hash.
function onSigninCallback(user?: User): void {
  const url = new URL(window.location.href);
  url.searchParams.delete('code');
  url.searchParams.delete('state');

  window.history.replaceState(window.history.state, document.title, url.pathname + url.search + url.hash);

  // send the user back to the deep link they were heading for before the login redirect
  const target = user?.url_state;
  if (target && target.startsWith('/') && target !== window.location.pathname) {
    window.location.replace(target);
  }
}

export function AuthProvider({ children }: PropsWithChildren): ReactElement {
  useEffect(() => {
    let redirecting = false;
    const redirectToLogin = () => {
      if (redirecting) return;
      redirecting = true;
      void userManager.signinRedirect({ url_state: window.location.pathname + window.location.search }).catch(() => {
        redirecting = false;
      });
    };
    userManager.events.addSilentRenewError(redirectToLogin);
    userManager.events.addAccessTokenExpired(redirectToLogin);
    return () => {
      userManager.events.removeSilentRenewError(redirectToLogin);
      userManager.events.removeAccessTokenExpired(redirectToLogin);
    };
  }, []);

  return (
    <OidcAuthProvider userManager={userManager} onSigninCallback={onSigninCallback}>
      {children}
    </OidcAuthProvider>
  );
}
